import { Vue, Component } from "vue-property-decorator";
import { t } from "../locale";

@Component({})
export default class Locale extends Vue {
  t: any = function (...args) {
    return t.apply(this, args);
  };
}
